// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"overview_wrapper__NuB3h","skeletonBlock":"overview_skeletonBlock__dec7B","skeletonText":"overview_skeletonText__2pKy4"};